'use client';

import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import ProductDesktop from './_components/product.desktop';
import ProductMobile from './_components/product.mobile';
import type { IProduct } from '@/entities/product/model/types';

export default function ProductResponsive({
  slug,
  onSuccess,
  shipperId,
  isModal,
  initialProduct,
}: {
  slug: string;
  onSuccess?: () => void;
  shipperId: string;
  isModal?: boolean;
  initialProduct?: IProduct | null;
}) {
  const isDesktop = useIsDesktop();

  if (isDesktop)
    return (
      <ProductDesktop
        slug={slug}
        onSuccess={onSuccess}
        shipperId={shipperId}
        isModal={isModal}
        initialProduct={initialProduct}
      />
    );
  return (
    <ProductMobile
      slug={slug}
      onSuccess={onSuccess}
      shipperId={shipperId}
      isModal={isModal}
      initialProduct={initialProduct}
    />
  );
}
